<div> 
    <app-relatorio-kardex-filtro
          [filtros]="filtros">
    </app-relatorio-kardex-filtro>
    <app-relatorio-kardex-lista
          [filtros]="filtros"
          (definirFiltro)="definirFiltro()"
          (exibir)="selecionar($event)">
    </app-relatorio-kardex-lista>
</div>